import Route from '@ember/routing/route';

export default class AuthViewsSuppliersRoute extends Route {}
